module.exports = __webpack_public_path__ + "facebook_icon.png?8b7ffb52970bd54221d2f81327c98f9c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook_icon.png
// module id = 25
// module chunks = 24